import { FC, FocusEvent, useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import type { ColumnProps } from './model';

interface TextColumnProps extends ColumnProps<string> {}

export const GridTextColumn: FC<TextColumnProps> = ({ value, id, setCellValue, placeholderKey }) => {
  const onBlur = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      if (value?.toString() !== event.currentTarget.value) {
        setCellValue(id, event.currentTarget.value);
      }
    },
    [id, setCellValue, value],
  );

  const [internalValue, setInternalValue] = useState<Nullable<string>>(value);

  const onInternalChange = useCallback((e: FocusEvent<HTMLInputElement>) => {
    setInternalValue(e.target.value || null);
  }, []);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const { formatMessage } = useIntl();

  return (
    <input
      placeholder={placeholderKey !== undefined ? formatMessage({ id: placeholderKey }) : undefined}
      className="form-control"
      type="text"
      onBlur={onBlur}
      onChange={onInternalChange}
      value={internalValue || ''}
    />
  );
};

GridTextColumn.displayName = 'GridTextColumn';
